"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.councilTypes = exports.CastVoteOf = exports.CouncilMemberOf = exports.CouncilMember = exports.Candidate = exports.CouncilStageUpdate = exports.CouncilStage = exports.CouncilStageElection = exports.CouncilStageAnnouncing = void 0;
const codec_1 = require("@polkadot/types/codec");
const types_1 = require("@polkadot/types");
const JoyStruct_1 = require("../JoyStruct");
const JoyEnum_1 = require("../JoyEnum");
const common_1 = require("../common");
const referendum_1 = require("../referendum");
class CouncilStageAnnouncing extends (0, JoyStruct_1.JoyStructDecorated)({
    candidatesCount: types_1.u64,
}) {
}
exports.CouncilStageAnnouncing = CouncilStageAnnouncing;
class CouncilStageElection extends (0, JoyStruct_1.JoyStructDecorated)({
    candidatesCount: types_1.u64,
}) {
}
exports.CouncilStageElection = CouncilStageElection;
class CouncilStage extends (0, JoyEnum_1.JoyEnum)({
    Announcing: CouncilStageAnnouncing,
    Election: CouncilStageElection,
    Idle: types_1.Null,
}) {
}
exports.CouncilStage = CouncilStage;
class CouncilStageUpdate extends (0, JoyStruct_1.JoyStructDecorated)({
    stage: CouncilStage,
    changed_at: types_1.u32,
}) {
}
exports.CouncilStageUpdate = CouncilStageUpdate;
class Candidate extends (0, JoyStruct_1.JoyStructDecorated)({
    staking_account_id: common_1.AccountId,
    reward_account_id: common_1.AccountId,
    cycle_id: types_1.u64,
    stake: types_1.u32,
    vote_power: referendum_1.VotePower,
    note_hash: codec_1.Option.with(common_1.Hash),
}) {
}
exports.Candidate = Candidate;
class CouncilMember extends (0, JoyStruct_1.JoyStructDecorated)({
    staking_account_id: common_1.AccountId,
    reward_account_id: common_1.AccountId,
    membership_id: common_1.MemberId,
    stake: types_1.u128,
    last_payment_block: types_1.u32,
    unpaid_reward: types_1.u128,
}) {
}
exports.CouncilMember = CouncilMember;
class CouncilMemberOf extends CouncilMember {
}
exports.CouncilMemberOf = CouncilMemberOf;
class CastVoteOf extends referendum_1.CastVote {
}
exports.CastVoteOf = CastVoteOf;
exports.councilTypes = {
    CouncilStageAnnouncing,
    CouncilStageElection,
    CouncilStageUpdate,
    CouncilStage,
    Candidate,
    CouncilMemberOf,
    CastVoteOf,
};
exports.default = exports.councilTypes;
